// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2d2C2","box":"WorkspacesBox_box__2otot","node":"WorkspacesBox_node__3prPe"};